<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月23日 11:12:37
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div :class="[isFlatThree ? 'Three-Screennursing-one' : '', isApp ? '' : 'nursing-one']">
    <transition name="head">
      <div v-if="!isFlatThreeFullScreen" class="head" :style="{ top: isApp ? '0' : '37px' }">
        <filterBtn @click="openFilter(true)"></filterBtn>
        <el-input class="search" placeholder="搜索长者" v-model="search">
          <el-image class="search-image" slot="prefix" :src="sousuo" fit="contain"></el-image>
        </el-input>
      </div>
    </transition>
    <div class="nursingItem-list">
      <template v-if="elderlyCaresList.length">
        <div class="nursingItem-container" v-for="item in elderlyCaresList" :key="item.Id" @click="goDetail(item)">
          <van-image round width="1.12rem" height="1.12rem" :src="item.ImgUrl || avatar" />
          <div class="detail">
            <div class="name">{{ item.Name }}</div>
            <div class="room">房间号：{{ item.Room }}</div>
          </div>
          <div class="look">查看</div>
        </div>
      </template>
      <tips v-else></tips>
    </div>
    <pager @changePage="changePage" @changeSize="changeSize" :page="page + 1" :total="total" :size="size"></pager>
  </div>
</template>

<script>
import nursingItem from '@/common/nursing-item.vue'
import filterBtn from '@/common/filter-btn.vue'
import pager from '@/common/pager.vue'
import tips from '@/common/tips.vue'
import { group } from '@/tool'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import photo from '@/assets/imgs/photo.png'
import avatar from '@/assets/imgs/avatar.png'
import sousuo from '@/assets/imgs/icon-sousuo-32@2x.png'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    nursingItem,
    filterBtn,
    pager,
    tips
  },
  // 组件状态值
  data() {
    return {
      search: '',
      isApp: true,
      size: 10,
      page: 0,
      total: 10,
      photo,
      avatar,
      sousuo
    }
  },
  // 计算属性
  computed: {
    ...mapState(['ElderlyCares', 'isFullScreen', 'timer', 'isFullScreen']),
    ...mapState('filter', ['selectRooms']),
    ...mapGetters(['isFlatThreeFullScreen', 'isFlatThree']),
    filtersElderlyCares() {
      let arr = this.ElderlyCares.filter((item) => {
        return (!this.selectRooms.length || this.selectRooms.indexOf(item.Room) != -1) && (!this.search || item.Name.indexOf(this.search) != -1)
      })
      this.total = arr.length
      if (this.page * this.size >= this.total) {
        this.page = 0
      }
      arr = group(arr, this.size)
      return arr || [[]]
    },
    elderlyCaresList() {
      return this.filtersElderlyCares[this.page] || []
    }
  },

  // 组件方法
  methods: {
    ...mapMutations(['resetTime', 'updateThree']),
    ...mapActions('filter', ['openFilter']),
    // 查看详情
    goDetail(val) {
      this.$router.push({
        path: '/record/detail',
        query: val
      })
    },
    // 切换总页数
    changeSize(size) {
      this.size = size
    },
    // 切换当前页
    changePage(page) {
      this.page = page
    }
  },
  created() {
    this.resetTime()
    this.isApp = localStorage.getItem('isApp') === '0'
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.nursing-one {
  margin: 0px;
  padding-bottom: 60px;
}
.head {
  position: fixed;
  top: 37px;
  left: 0px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  z-index: 1;
}

.no-header {
  top: 0px !important;
}
/* .head::after{
  position: absolute;
  width: 80%;
} */

.search-image {
  width: 16px;
  height: 16px;
  margin: 9px 4px 10px 10px;
}
.search,
.head >>> .el-input__inner {
  width: 274px;
  height: 35px;
  font-size: 12px;
  background: #f4f4f4;
  border: 1px solid #f4f4f4;
}
.search {
  font-size: 14px;
}
.head >>> .el-input--prefix .el-input__inner {
  padding-left: 32px;
}
.nursingItem-container {
  display: flex;
  align-items: center;
  margin: 12px 0px;
  padding: 12px 20px;
  background: #fff;
  border-radius: 4px;
}

.nursingItem-container .detail {
  flex: 1;
  margin-left: 12px;
  font-size: 16px;
}

.nursingItem-container .name {
  line-height: 2;
  color: #029fd1;
}

.nursingItem-container .room {
  line-height: 2;
}

.nursingItem-container .look {
  padding: 4px 10px;
  border-radius: 3px;
  background-color: #dcf7ff;
  font-size: 16px;
  color: #029fd1;
}

.nursingItem-list {
  padding: 60px 15px 0px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/record/index.vue